import { createContext } from 'react';

import type { AddToCartResult, CartState, CartSummary } from './cart.types';

export interface CartActions {
  /** Retorna o que realmente aconteceu, para a UI avisar em caso de limite. */
  addItem: (sku: string, quantity?: number) => AddToCartResult;
  setQuantity: (sku: string, quantity: number) => void;
  removeItem: (sku: string) => void;
  /** Remove de uma vez tudo o que saiu de estoque. */
  removeUnavailable: () => void;
  clearCart: () => void;
  openCart: () => void;
  closeCart: () => void;
  setCartOpen: (isOpen: boolean) => void;
}

/**
 * Três contexts em vez de um.
 *
 * As ações têm identidade estável, então um componente que só adiciona ao
 * carrinho (todo card de produto) assina `CartActionsContext` e não
 * re-renderiza nenhuma vez quando o conteúdo do carrinho muda.
 */
export const CartStateContext = createContext<CartState | null>(null);
export const CartSummaryContext = createContext<CartSummary | null>(null);
export const CartActionsContext = createContext<CartActions | null>(null);

/** Guarda compartilhada para todo hook do carrinho falhar com a mesma mensagem. */
export function assertCartContext<T>(value: T | null, hook: string): T {
  if (value === null) {
    throw new Error(`${hook}() precisa ser usado dentro de <CartProvider>.`);
  }
  return value;
}
